import React, { useContext } from "react";
import { FaArrowRight } from "react-icons/fa";
import Logo from "../../../utils/logo";
import { fontstyle1, fontstyle2 } from "../../../utils/fonts";
import logo from "../../../assets/logo.png";
import ThemeContext from "../../../context";
import ColorsTheme from "../../../utils/colors";

const HeroSection = () => {
  const { theme } = useContext(ThemeContext);
  const colortheme = ColorsTheme[theme];

  return (
    <div
      className={`w-full h-[100%] sm:h-[50vh] p-4 flex flex-col-reverse gap-10 sm:flex-row sm:gap-0 items-center justify-between ${
        theme === "light" ? "bg-[#F8F6F7]" : colortheme.background
      } ${colortheme.color}`}
    >
      <div className="flex flex-col items-center sm:items-start">
        <Logo />
        <p
          style={fontstyle2}
          className="w-60 sm:w-80 mt-2 text-center sm:text-left"
        >
          A platform to connect the database for your feedback forms.
        </p>
        <a href="/signup">
          <div
            className="mt-5 p-2 bg-[#FF834F] text-white rounded pl-5 pr-5 cursor-pointer flex items-center gap-3"
            style={fontstyle1}
          >
            <FaArrowRight />
            Get Started
          </div>
        </a>
      </div>
      <div>
        <img src={logo} alt="logo" className="w-20 h-20 sm:w-40 sm:h-40" />
      </div>
    </div>
  );
};
export default HeroSection;
